import React from 'react';
import Type from 'prop-types';
import { Link, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import { Description as DescriptionIcon } from '@material-ui/icons';
import { formatDate, fullDateFormat } from 'utils/date';
import useStyles from './Document.styles';

const Document = props => {
  const classes = useStyles();
  const { document: doc } = props;
  const documentDate = formatDate(doc.date, fullDateFormat);

  return (
    <ListItem button component={Link} href={doc.url} target="_blank" rel="noreferrer noopener">
      <ListItemIcon>
        <DescriptionIcon />
      </ListItemIcon>
      <ListItemText
        primary={documentDate}
        secondary={doc.title}
        classes={{ secondary: classes.documentTitle }}
      />
    </ListItem>
  );
};

Document.propTypes = {
  document: Type.shape({
    date: Type.string.isRequired,
    title: Type.string.isRequired,
    url: Type.string.isRequired,
  }).isRequired,
};

export default Document;
